export default __webpack_public_path__ + "static/media/svg-2.e78c9ec7.svg";